import { StyleProps } from "@shared/primitive-components"

export const root = (isLink?: boolean) => (props: StyleProps) => ({
  cursor: isLink ? `pointer` : `auto`,
  display: `flex`,
  alignItems: `center`,
  justifyContent: `center`,
  height: `80px`,
  width: `auto`,
  [props.theme.breakPoints.md.up]: {
    width: `100%`,
  },
})
